import {useEffect, useState} from "react";
import {axiosGetListFiles} from "../../../Api/ApiFiles/axiosGetListFiles";
import useAxiosPrivate from "../useAxiosPrivate/useAxiosPrivate";

function useGetListTemplate(userOrganization, docType) {

    const axiosPrivate = useAxiosPrivate();
    const [isOptionsTemplate, setOptionsTemplate] = useState([]);

    useEffect(() => {

        let isLoading = true;

        if (userOrganization !== undefined) {
            axiosGetListFiles(axiosPrivate, docType, userOrganization.id, isLoading, setOptionsTemplate )
        }

        return () => {
            isLoading = false;
        }

    }, [userOrganization]);

    return {isOptionsTemplate};
}

export default useGetListTemplate;
